import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { environment } from '../../environments/environment';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css']
})
export class DocumentsComponent implements OnInit {
  uploadDir: string = environment.uploadDir;
  @ViewChild('fileInput') fileInput;
  selectedOption: string;
  uploads_name: any = {};
  model: any;
  user: any = {};
  p: number = 1;
  results: any = {};
  onlyview: boolean;
  currentUser: any = {};
  currentOrg: any;
  formdata: FormData;
  upname: any;
  targetfile: any;
  Emp_Id: any;
  headerLabel: string;
  dataresult: any = [];
  recordsperpage: number = 25;
  showLoader: boolean;
  module_access: any;
  addAccess: boolean = false;
  editAccess: boolean = false;
  viewAccess: boolean = false;
  deleteAccess: boolean = false;
  constructor(private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService) {
    this.uploads_name.inventory_manager_upload_path = {
      file_name: '',
      file_temp_name: '',
    };
  }

  ngOnInit() {
    this.model = {
      ...this.model,
      resume_path: '',
      document_name: '',
      description: ''
    }
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_access = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_access = ''
      }
    } else {
      this.module_access = ''
    }
    var checkAccess = this.checkModuleAcces('30');
    if (!checkAccess) {
      alert("You don't have access for this module. Please contact admin.")
      this.router.navigate(['/Selectport']);
      return;
    }
    this.getDocuments();
  }

  upload(f, name) {

    // if (this.model.id) {
    if (f.target.files[0]) {
      const formData = new FormData();
      formData.append(name, f.target.files[0]);
      this.formdata = formData;
      this.upname = name;
      this.targetfile = f.target.files[0];
      this.uploads_name.inventory_manager_upload_path = { file_name: f.target.files[0].name };
      this.model.resume_path = f.target.files[0].name;
    }
    // } else {
    //   this._flashMessagesService.show('Please Choose Employee', { cssClass: 'alert-danger' });
    // }

  }

  getDocuments() {
    this.loginservice.getDocuments(this.currentUser)
      .subscribe(
        data => {
          this.dataresult = data;
        }, error => { alert('Network Error saveAccess API'); });
  }

  save() {
    if (this.targetfile && this.model.document_name) {
      this.uploadmanager(this.formdata, this.upname, this.Emp_Id)
    } else {
      alert('Document Name & Document Is Required')
      this._flashMessagesService.show('Document Name & Document Is Required', { cssClass: 'alert-danger' });
    }
  }

  uploadmanager(formData, name, Emp_Id) {
    this.showLoader = true;
    this.loginservice.uploadFile3(formData, name, 'documents', this.model['document_name'], this.model['description'], this.currentUser['uid']).subscribe(r => {
      if (r['status'] === 'success') {
        var path_name = name + '_path';
        this.uploads_name[path_name] = r;
        this.model['resume_temp_path'] = r['resume_temp_path'];
        this.model['resume_path'] = r['file_name'];
        // this.router.navigate(['/inventory-manager']);
      } else {
        this._flashMessagesService.show(r['message'], { cssClass: 'alert-danger' });
        // this.router.navigate(['/inventory-manager']);
      }
      this.showLoader = false;
      this.ngOnInit();
    },
      error => {
        alert('Network Error uploadmanager API');
        this.showLoader = false;
        this._flashMessagesService.show('Error in the Data/Server', { cssClass: 'alert-danger' });
        this.ngOnInit();
        // this.router.navigate(['/inventory-manager']);
      });
  }

  delete(id) {
    if (confirm('Deleting of this document is done from the entire system')) {
      if (confirm('Are you sure want to delete')) {
        this.loginservice.deleteupload(id, 'id', 'documents').subscribe(data => {
          this.getDocuments();
        }, error => { alert('Network Error delete API'); });
      }
    }
  }

  changeRecordPerPage(value) {
    this.recordsperpage = value;
  }


  checkModuleAcces(module_id: string): boolean {
    if (!this.module_access) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);
    if (mod) {
      // Set individual access flags
      this.addAccess = !!mod.add;
      this.editAccess = !!mod.edit;
      this.viewAccess = !!mod.view;
      this.deleteAccess = !!mod.delete;
      return true; // module exists
    } else {
      // If not found, reset and return false
      this.addAccess = false;
      this.editAccess = false;
      this.viewAccess = false;
      this.deleteAccess = false;
      return false;
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/documents/documents.component.ts